import type React from 'react';

import { type DialogProps } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions, { type DialogActionsProps } from '@mui/material/DialogActions';
import DialogContent, { type DialogContentProps } from '@mui/material/DialogContent';
import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle';

import { useStyles } from 'components/dialogs/styles';

const TMXDialog: React.FC<React.PropsWithChildren<DialogProps>> = ({ children, className, ...props }) => {
  const { classes, cx } = useStyles();
  return (
    <Dialog {...props} className={cx(classes.TMXDialog, className)}>
      {children}
    </Dialog>
  );
};

export const TMXDialogTitle: React.FC<React.PropsWithChildren<DialogTitleProps>> = ({ className, ...props }) => {
  const { classes, cx } = useStyles();
  return <DialogTitle className={cx(classes.TMXDialogTitle, className)} {...props} />;
};

export const TMXDialogContent: React.FC<React.PropsWithChildren<DialogContentProps>> = ({ className, ...props }) => {
  const { classes, cx } = useStyles();
  return <DialogContent className={cx(classes.TMXDialogContent, className)} {...props} />;
};

export const TMXDialogActions: React.FC<React.PropsWithChildren<DialogActionsProps>> = ({ className, ...props }) => {
  const { classes, cx } = useStyles();
  return <DialogActions className={cx(classes.TMXDialogActions, className)} {...props} />;
};

export type TMXDialogProps = DialogProps;
export type TMXDialogTitleProps = DialogTitleProps;
export type TMXDialogContentProps = DialogContentProps;
export type TMXDialogActionsProps = DialogActionsProps;

export default TMXDialog;
